import { Collapsible, Space, SubText } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { ConversationTelemetryDataStyled } from './styles/ConversationTelemetryDataStyled'
import { ConversationTelemetryScrollStyled } from './styles/ConversationTelemetryScrollStyled'
import { ConversationTelemetryShellStyled } from './styles/ConversationTelemetryStyled'
import { type ConversationTelemetryEvent } from '../../../../value-objects/ConversationTelemetryEvent'

export interface IConversationTelemetryProps {
  events: ConversationTelemetryEvent[]
}

export const ConversationTelemetry = ({
  events,
}: IConversationTelemetryProps) => {
  const intl = useProcurifyIntl()

  return (
    <ConversationTelemetryShellStyled>
      <Collapsible
        title={intl.formatMessage(messages.title, { count: events.length })}
      >
        <ConversationTelemetryScrollStyled>
          <Space direction='vertical' size='xsmall'>
            {events.map((event, index) => (
              <Space
                key={`${event.timestamp ?? 'no-ts'}_${event.type}_${index}`}
                direction='vertical'
                size='xsmall'
              >
                <Space direction='horizontal' size='xsmall' align='baseline'>
                  <SubText inline>{event.timestamp ?? ''}</SubText>
                  <strong>{event.type}</strong>
                </Space>
                <ConversationTelemetryDataStyled>
                  {JSON.stringify(event.data, null, 2)}
                </ConversationTelemetryDataStyled>
              </Space>
            ))}
          </Space>
        </ConversationTelemetryScrollStyled>
      </Collapsible>
    </ConversationTelemetryShellStyled>
  )
}
